/** Auto-extracted from 蝴蝶影视平台.html — zh, en, de, ko only */
export const I18N = {
  "zh": {
    "nav_home": "项目广场",
    "nav_rules": "平台规则",
    "nav_dash": "个人中心",
    "network": "BSC 主网",
    "wallet_btn": "◇ 连接钱包",
    "wallet_on": "◈ 已连接",
    "hero_eyebrow": "好故事值得一个未来",
    "hero_h1": "让好故事被看见<br>让每一份参与，<span>皆有回响</span>",
    "hero_p": "连接影视创作者与价值共创者<br>以 NFT 记录参与，让影视募资更加透明。",
    "hero_explore": "探索影视项目",
    "hero_launch": "＋ 发起项目",
    "hero_caption": "A NEW CHAPTER IN CINEMA INVESTMENT",
    "stat1": "平台展示项目",
    "stat1u": "个",
    "stat2": "平台 NFT 发行总量",
    "stat2u": "张",
    "stat3": "项目方可选定价",
    "stat3u": "单一币种 · 项目自定义",
    "stat4": "推广奖励最高比例",
    "stat4u": "最多 15 代",
    "poster_label": "NO. {n} / ORIGINAL PICTURES",
    "sec_projects": "发现好故事",
    "sec_projects_sub": "独立发行 · 自主规则 · 共同参与",
    "filter_all": "全部项目",
    "filter_live": "募集中",
    "filter_soon": "即将上线",
    "poster_bottom": "每一份微光，终将成为银幕上的光芒",
    "tag_debut": "平台首发项目",
    "live_demo": "● 募集中",
    "sub_issuer": "发行方",
    "sub_nft": "以一张 NFT，参与一个故事的诞生。",
    "sub_issuer_nft": "发行方 · 蝴蝶影视<br>以一张 NFT，参与一个故事的诞生。",
    "price_unit": "/ 张 NFT",
    "progress_label": "认购进度",
    "limited": "限量发行",
    "view_project": "查看项目 & 参与认购 ↗",
    "launch_title": "下一个好故事，由你开启",
    "launch_sub": "面向影视发行方的开放式募资平台。<br>自主展示项目、发行 NFT、连接支持者。",
    "launch_steps": "01 &nbsp; 提交项目资料<br>02 &nbsp; 明确权益与发行规则<br>03 &nbsp; 开启项目募集",
    "launch_btn": "成为发行方 ↗",
    "empty_soon": "新的故事正在筹备中<br>暂无即将上线的项目",
    "feat1": "认购即记录",
    "feat1p": "每张 NFT 对应一份项目参与记录<br>链上记录与权益以发行方披露为准",
    "feat2": "分账规则，一目了然",
    "feat2p": "项目方至少获得 70%，推荐最多 30%<br>未分配奖励自动归项目方",
    "feat3": "独立发行，独立披露",
    "feat3p": "项目方自主展示未来收益分配规则<br>不代表平台担保或链上自动分红",
    "detail_back": "← 返回项目广场",
    "detail_tag": "首发项目 #001",
    "detail_live": "● 认购开放",
    "detail_sub": "发行方：{issuer} &nbsp; / &nbsp; 发行 {supply} 张 NFT &nbsp; / &nbsp; 每张 {price} · {coin}",
    "notice_demo": "NFT 是否代表可执行的股权权益，须以正式协议和适用法律为准。认购与奖励规则以平台及发行方披露为准。",
    "about_title": "项目介绍",
    "about_p1": "蝴蝶影视是平台首个展示项目，计划发行 1,000 张项目 NFT。支持 AAPLB / USDT / BNB 三种代币认购，可选用固定价或递增式定价：递增模式下第 1 张 1 AAPLB，每张 +0.1 AAPLB，递增值与起始价均由发行方配置。",
    "about_p2": "影片类型、制作团队、预算、拍摄进度及权益法律文件尚待发行方披露。本平台不编造影片履历、投资业绩或收益承诺。",
    "tag_film": "影视项目",
    "tag_nft": "限量 NFT",
    "tag_issue": "自主发行",
    "sub_title": "参与项目认购",
    "supply_total": "发行总量",
    "supply_total_v": "1,000 张",
    "supply_left": "已认购 / 剩余",
    "target": "募集目标",
    "target_v": "1,000 AAPLB",
    "my_holding": "我的持有",
    "buy_btn": "参与认购 ↗",
    "buy_note": "认购需连接钱包并完成链上支付",
    "alloc_title": "认购资金分配",
    "alloc_issuer": "发行方基础所得",
    "alloc_level": "每代有效上级",
    "alloc_note": "上级奖励池最多为认购额的 30%。不足 15 代时，未分配部分自动归项目方。",
    "view_rules": "查看计算规则 →",
    "revenue_title": "未来收益分配方案",
    "revenue_tag": "发行方披露 · 仅展示",
    "donut_label": "收益分配构成",
    "revenue_note": "此方案与认购资金的 70% / 30% 分账是两套独立规则。以上为蝴蝶影视自主设定的未来收益分配展示，不代表收益承诺。收益口径、结算周期及投资者内部的分配方式待发行方披露。",
    "alloc_director": "导演",
    "alloc_writer": "编剧",
    "alloc_distributor": "发行公司",
    "alloc_producer": "承制公司",
    "alloc_partner": "蝴蝶影视合伙人",
    "alloc_treasury": "蝴蝶金库股权",
    "alloc_buyback": "回购蝴蝶人生销毁",
    "alloc_marshal": "元帅NFT股东",
    "alloc_metal": "金银铜NFT股东",
    "alloc_investor": "投资者",
    "rules_title": "清晰的规则，透明的参与",
    "rules_sub": "区分认购资金分账与项目未来收益，让每一份参与有据可循。",
    "rules_h3": "首发项目 · 认购分账规则",
    "step1b": "01 / 认购",
    "step1p": "支持 AAPLB · USDT · BNB 认购<br>可设固定价或递增价 · 各项目独立发行规则",
    "step2b": "02 / 推广分账",
    "step2p": "每代上级获得认购金额的 2%<br>最多计算 15 代，累计不超过 30%",
    "step3b": "03 / 项目方到账",
    "step3p": "项目方获得基础 70%<br>不足 15 代的剩余奖励归项目方",
    "notice_rules": "这里的 2% 来自每次认购金额，不额外向购买者加收费用。例如，认购 1 张且有 3 代有效上级时：上级合计 0.06 AAPLB，项目方获得 0.94 AAPLB。",
    "prelaunch_title": "上线前需要明确的事项",
    "li1": "股权、收益权与 NFT 的法律关系及书面协议。",
    "li2": "投资者适当性、发行资质、地域限制与身份核验。",
    "li3": "AAPLB 所在链、代币地址与小数位数。",
    "li4": "推荐关系的绑定时机、防自荐及循环关系规则。",
    "li5": "15 代奖励资格、提现机制及异常地址处理。",
    "li6": "募集期限、未达目标的退款与资金托管。",
    "li7": "合约安全审计与项目资料披露。",
    "notice_compliance": "影视股权募资与多层级推广涉及证券发行及反传销等合规风险。正式上线前应完成相关司法辖区的专业法律评估。本平台不构成发行许可或投资建议。",
    "dash_title": "我的参与，每一份都算数",
    "dash_tag": "个人数据",
    "acc_off": "尚未连接钱包",
    "acc_on": "已连接钱包",
    "m1": "累计认购",
    "m1u": "张 NFT · 链上持有",
    "m2": "认购支出",
    "m2u": "按项目币种 · 支付",
    "m3": "直接推广人数",
    "m3u": "团队 {team} 人 · 推广数据",
    "m4": "累计推广奖励",
    "m4u": "按 2% / 代 · 奖励入账",
    "tab_p": "认购记录",
    "tab_r": "奖励记录",
    "tab_t": "推广团队",
    "share_title": "分享好故事，邀请同行者",
    "share_sub": "我的专属推荐链接<br>按有效上级关系分账，每代 2%，最多 15 代。",
    "copy": "复制",
    "share_note": "推荐链接可携带推荐标记；按有效上级关系参与分账。",
    "my_nft": "我的 NFT",
    "nft_name": "蝴蝶影视 · 首期",
    "nft_none": "尚未认购",
    "view": "查看",
    "footer1": "连接创作与参与，让故事拥有更多可能。",
    "footer2": "不承诺投资收益 · 投资存在风险",
    "footer3": "NFT 不当然等同于法定股权，投资存在本金损失风险。",
    "wallet_title": "连接钱包",
    "wallet_sub": "请选择钱包连接 BSC 主网，用于认购与链上交互。",
    "wallet_notice": "连接后可参与认购、查看持有记录并使用个人推荐链接。",
    "wallet_enter": "确认连接",
    "purchase_title": "认购蝴蝶影视 NFT",
    "purchase_sub": "单币种认购 &nbsp; · &nbsp; 总量 1,000 张",
    "buy_qty": "认购数量",
    "pay": "支付",
    "pay_coin": "支付币种",
    "pay_coin_note": "本项目仅支持一种代币支付",
    "upline": "有效上级",
    "upline_v": "0 代（未绑定关系）",
    "issuer_pay": "项目方到账（含剩余奖励）",
    "risk_check": "我已了解 NFT 权益以正式协议为准，影视项目收益不确定，本页不作收益承诺。",
    "confirm_buy": "确认认购",
    "purchase_note": "请确认认购数量与支付金额",
    "apply_title": "让你的故事，在这里启幕",
    "apply_sub": "发行方入驻资料 · 提交后进入审核",
    "f_project": "项目名称",
    "f_project_ph": "请输入影视项目名称",
    "f_issuer": "发行主体",
    "f_issuer_ph": "公司或发行主体名称",
    "f_mode": "定价模式",
    "mode_fixed": "固定价格",
    "mode_step": "递增式",
    "f_price_fixed": "固定单价",
    "f_price_step": "递增参数",
    "unit_price": "单价",
    "start_price": "起始价",
    "step_price": "每张递增值",
    "f_supply": "计划发行 NFT 数量",
    "f_supply_ph": "例如 1000",
    "f_image": "NFT 封面图 <em class=\"req\">（必传）</em>",
    "upload_hint": "＋ 点击上传 NFT 封面图<br><small>JPG / PNG，建议 1:1，≤ 5MB</small>",
    "apply_notice": "需完成发行资质审核与权益披露。提交后由平台审核，审核通过后方可上线项目。",
    "apply_submit": "提交申请",
    "apply_ok": "✓ 资料已提交",
    "apply_ok_sub": "申请已进入审核队列。<br>审核结果将通过平台通知。",
    "th_project": "项目 / 时间",
    "th_qty": "数量",
    "th_coin": "币种",
    "th_spent": "支出",
    "th_status": "状态",
    "th_gen": "代数",
    "th_count": "人数",
    "th_amount": "奖励",
    "th_date": "时间",
    "th_team_no": "序号",
    "th_team_addr": "直推地址",
    "status_done": "已完成",
    "card_price_note": "单币种支付 · 由发行方指定",
    "next_price": "下一张价格",
    "step_note": "递增定价：第 n 张价格 = 起始价 + (n-1) × 每张递增值",
    "step_note_c": "递增定价 · 起始 {start} / 张 · 每张 +{inc}",
    "empty_p": "尚无认购记录 · 参与认购，开启你的影视之旅",
    "empty_r": "暂无推广奖励",
    "empty_t": "暂无推广团队",
    "toast_save": "浏览器存储不可用，请检查浏览器设置",
    "toast_connected": "钱包已连接",
    "toast_wallet": "钱包已连接",
    "toast_connect": "请先连接钱包",
    "toast_qty": "请输入 1 至 {max} 之间的整数",
    "toast_risk": "请先阅读并勾选风险提示",
    "toast_buy": "认购成功，已记录 {n} 张 NFT",
    "toast_copied": "推荐链接已复制",
    "toast_copy_manual": "请按 Ctrl+C 复制已选中的推荐链接",
    "toast_img_type": "请选择 JPG / PNG 图片文件",
    "toast_img_size": "图片不能超过 5MB，请压缩后重试",
    "toast_img_ready": "NFT 封面图已就绪",
    "toast_img_fail": "图片读取失败，请更换后重试",
    "toast_need_image": "请先上传一张 NFT 封面图",
    "toast_applied": "发行资料已提交",
    "toast_preview": "项目已记录",
    "toast_soldout": "已售罄",
    "toast_ref": "已识别推荐标记",
    "toast_input_pos": "请输入正整数",
    "ref_connect": "请先连接钱包",
    "buy_soldout": "已售罄",
    "my_hold": "持有 {n} 张 NFT",
    "record_name": "蝴蝶影视",
    "user_pb": "你发行的 NFT 封面 · 待审核",
    "user_tag": "待审核项目",
    "live_now": "● 募集中",
    "user_sub2": "NFT 封面已随发行申请上传，等待平台审核。",
    "view_preview": "查看我的项目 ↗",
    "poster_label_u": "NO. {n} / YOUR PICTURES",
    "result_note": "审核通过后项目将上线展示。",
    "result_line": "发行方 · {issuer}　｜　{pricing}　｜　{supply} 张　｜　{date}",
    "soldout_btn": "已售罄",
    "calc_title": "认购分账说明",
    "f_description": "项目简介",
    "f_description_ph": "向投资者介绍影片与发行计划（将写入 NFT 元数据）",
    "empty_projects": "链上暂无已发行项目<br>成为第一个发起项目的人",
    "apply_submitting": "链上提交中…",
    "toast_launch_ok": "项目已成功上链发行",
    "toast_subscribing": "链上认购中…",
    "toast_subscribe_ok": "认购成功",
    "toast_chain_load": "正在同步链上项目…",
    "toast_chain_fail": "链上数据加载失败",
    "toast_img_uploading": "封面图上传中…",
    "toast_img_upload_fail": "封面上传失败，请重试",
    "toast_launch_pay_token": "该支付币种未在链上开启，发行请选 AAPLB",
    "coin_launch_off": "链上未开启",
    "buy_need_address": "缺少 NFT 合约地址，暂不可认购",
    "toast_no_card_address": "该项目缺少 NFT 合约地址，无法链上认购"
  },
  "en": {
    "nav_home": "Projects",
    "nav_rules": "Rules",
    "nav_dash": "Dashboard",
    "network": "BSC Mainnet",
    "wallet_btn": "◇ Connect Wallet",
    "wallet_on": "◈ Connected",
    "hero_eyebrow": "Stories deserve a future",
    "hero_h1": "Let great stories be seen<br>Let every stake, <span>echo back</span>",
    "hero_p": "Connecting filmmakers with value co-creators<br>NFT records your participation · transparent film fundraising.",
    "hero_explore": "Explore Projects",
    "hero_launch": "＋ Launch a Project",
    "hero_caption": "A NEW CHAPTER IN CINEMA INVESTMENT",
    "stat1": "Projects Listed",
    "stat1u": "",
    "stat2": "Platform NFT Supply",
    "stat2u": "NFTs",
    "stat3": "Issuer-selectable Pricing",
    "stat3u": "single coin · set by project",
    "stat4": "Max Referral Reward",
    "stat4u": "up to 15 levels",
    "poster_label": "NO. {n} / ORIGINAL PICTURES",
    "sec_projects": "Discover Great Stories",
    "sec_projects_sub": "Independent issuance · Own rules · Joint participation",
    "filter_all": "All",
    "filter_live": "Live",
    "filter_soon": "Coming Soon",
    "poster_bottom": "Every glimmer of light will one day shine on the screen",
    "tag_debut": "Platform Debut",
    "live_demo": "● Live",
    "sub_issuer": "Issuer",
    "sub_nft": "Own an NFT and witness a story being born.",
    "sub_issuer_nft": "Issuer · Butterfly Pictures<br>Own an NFT and witness a story being born.",
    "price_unit": "/ NFT",
    "progress_label": "Subscription progress",
    "limited": "Limited",
    "view_project": "View Project & Subscribe ↗",
    "launch_title": "The next great story starts with you",
    "launch_sub": "An open fundraising platform for film issuers.<br>Show your project, issue NFTs, connect supporters.",
    "launch_steps": "01 &nbsp; Submit project details<br>02 &nbsp; Define rights & rules<br>03 &nbsp; Open the raise",
    "launch_btn": "Become an Issuer ↗",
    "empty_soon": "New stories are in preparation<br>No upcoming projects yet",
    "feat1": "Participation, recorded",
    "feat1p": "Each NFT maps to a project participation record<br>On-chain records and rights follow issuer disclosure",
    "feat2": "Clear revenue sharing",
    "feat2p": "Issuer receives at least 70%, referrals up to 30%<br>Unallocated rewards return to the issuer",
    "feat3": "Independent issuance & disclosure",
    "feat3p": "Issuers disclose future revenue allocation rules<br>Not a platform guarantee or on-chain dividend",
    "detail_back": "← Back to Projects",
    "detail_tag": "Debut #001",
    "detail_live": "● Subscription Open",
    "detail_sub": "Issuer: {issuer} &nbsp;/&nbsp; {supply} NFTs &nbsp;/&nbsp; {price} · {coin} each",
    "notice_demo": "Whether an NFT represents enforceable equity depends on the formal agreement and applicable law. Subscription and reward rules follow platform and issuer disclosure.",
    "about_title": "About the Project",
    "about_p1": "Butterfly Pictures is the platform’s first showcase project, issuing 1,000 project NFTs. Subscriptions accept AAPLB / USDT / BNB, under either fixed or step-up pricing — in step-up mode the 1st NFT costs 1 AAPLB, +0.1 AAPLB per NFT, with both start price and increment configured by the issuer.",
    "about_p2": "Genre, team, budget, progress and legal documents are pending issuer disclosure. This platform does not invent film history, performance or return promises.",
    "tag_film": "Film Project",
    "tag_nft": "Limited NFT",
    "tag_issue": "Self-Issued",
    "sub_title": "Subscribe to This Project",
    "supply_total": "Total Supply",
    "supply_total_v": "1,000 NFTs",
    "supply_left": "Subscribed / Remaining",
    "target": "Raise Target",
    "target_v": "1,000 AAPLB",
    "my_holding": "My holding",
    "buy_btn": "Subscribe ↗",
    "buy_note": "Connect wallet and complete on-chain payment to subscribe",
    "alloc_title": "Subscription Fund Split",
    "alloc_issuer": "Issuer Base Share",
    "alloc_level": "Upline per Level",
    "alloc_note": "The upline pool is at most 30% of the subscription. With fewer than 15 levels, the unallocated share returns to the issuer.",
    "view_rules": "View Calculation Rules →",
    "revenue_title": "Future Revenue Allocation Plan",
    "revenue_tag": "Issuer Disclosure · Display Only",
    "donut_label": "Allocation Structure",
    "revenue_note": "This allocation is separate from the 70% / 30% split of subscription funds. It is issuer-disclosed future revenue display only, not a return promise.",
    "alloc_director": "Director",
    "alloc_writer": "Writer",
    "alloc_distributor": "Distributor",
    "alloc_producer": "Production Co.",
    "alloc_partner": "Butterfly Partner",
    "alloc_treasury": "Butterfly Treasury",
    "alloc_buyback": "Buyback & Burn",
    "alloc_marshal": "Marshal NFT Holders",
    "alloc_metal": "Gold-Silver-Copper NFT",
    "alloc_investor": "Investors",
    "rules_title": "Clear rules, transparent participation",
    "rules_sub": "Distinguishing subscription splits from future project revenue — every participation is traceable.",
    "rules_h3": "Debut Project · Subscription Split Rules",
    "step1b": "01 / Subscribe",
    "step1p": "Pay with AAPLB · USDT · BNB<br>Fixed or step-up pricing · Butterfly Pictures issues 1,000 fixed",
    "step2b": "02 / Referral Split",
    "step2p": "Each upline gets 2% of the amount<br>Up to 15 levels, capped at 30%",
    "step3b": "03 / Issuer Receives",
    "step3p": "Issuer gets base 70%<br>Remaining rewards below 15 levels go to issuer",
    "notice_rules": "The 2% comes from each subscription amount, with no extra fee charged to buyers. Example: subscribing 1 NFT with 3 valid uplines — uplines share 0.06 AAPLB, issuer receives 0.94 AAPLB.",
    "prelaunch_title": "To Clarify Before Launch",
    "li1": "Legal relationship between equity, income rights and NFT, plus written agreements.",
    "li2": "Investor suitability, issuance qualifications, geographic restrictions and identity verification.",
    "li3": "AAPLB chain, token address and decimals.",
    "li4": "Referral binding timing, self-referral prevention and loop rules.",
    "li5": "15-level reward eligibility, withdrawal mechanics and abnormal address handling.",
    "li6": "Raise period, refunds if target not met, and fund custody.",
    "li7": "Smart contract security audit and project disclosure.",
    "notice_compliance": "Film equity fundraising and multi-level referrals involve securities and compliance risks. Professional legal review is required in relevant jurisdictions. This platform is not a license to issue or investment advice.",
    "dash_title": "Every participation counts",
    "dash_tag": "Personal data",
    "acc_off": "Wallet not connected",
    "acc_on": "Wallet connected",
    "m1": "Total Subscribed",
    "m1u": "NFTs · on-chain holdings",
    "m2": "Amount Spent",
    "m2u": "AAPLB",
    "m3": "Direct Referrals",
    "m3u": "Team 0 · not bound yet",
    "m4": "Total Referral Rewards",
    "m4u": "AAPLB · no rewards yet",
    "tab_p": "Purchases",
    "tab_r": "Rewards",
    "tab_t": "Team",
    "share_title": "Share great stories, invite companions",
    "share_sub": "My referral link<br>2% per valid upline level, up to 15 levels.",
    "copy": "Copy",
    "share_note": "Referral links may carry a tag; rewards follow valid upline relationships.",
    "my_nft": "My NFTs",
    "nft_name": "Butterfly Pictures · Round 1",
    "nft_none": "Not subscribed yet",
    "view": "View",
    "footer1": "Connecting creation and participation — giving stories more possibilities.",
    "footer2": "No investment return promises · risk of loss",
    "footer3": "An NFT is not automatically legal equity; principal loss risk exists.",
    "wallet_title": "Connect Wallet",
    "wallet_sub": "Connect a wallet on BSC Mainnet to subscribe and interact on-chain.",
    "wallet_notice": "After connecting you can subscribe, view holdings, and use your referral link.",
    "wallet_enter": "Connect",
    "purchase_title": "Subscribe Butterfly Pictures NFT",
    "purchase_sub": "Single-coin subscription &nbsp;·&nbsp; Total 1,000",
    "buy_qty": "Quantity",
    "pay": "Payment",
    "pay_coin": "Pay with",
    "pay_coin_note": "This project accepts only one coin",
    "upline": "Valid Uplines",
    "upline_v": "0 levels (not bound)",
    "issuer_pay": "Issuer receipt (incl. remainder)",
    "risk_check": "I understand NFT rights follow the formal agreement; film returns are uncertain and this page promises nothing.",
    "confirm_buy": "Confirm subscription",
    "purchase_note": "Please confirm quantity and payment amount",
    "apply_title": "Let your story premiere here",
    "apply_sub": "Issuer onboarding · submitted for review",
    "f_project": "Project Name",
    "f_project_ph": "Enter film project name",
    "f_issuer": "Issuing Entity",
    "f_issuer_ph": "Company or issuer name",
    "f_mode": "Pricing Mode",
    "mode_fixed": "Fixed Price",
    "mode_step": "Step-up",
    "f_price_fixed": "Fixed Unit Price",
    "f_price_step": "Step-up Parameters",
    "unit_price": "Unit Price",
    "start_price": "Start Price",
    "step_price": "Increment / NFT",
    "f_supply": "Planned NFT Supply",
    "f_supply_ph": "e.g. 1000",
    "f_image": "NFT Cover <em class=\"req\">(required)</em>",
    "upload_hint": "＋ Click to upload NFT cover<br><small>JPG / PNG, 1:1 recommended, ≤ 5MB</small>",
    "apply_notice": "Issuance qualification and rights disclosure required. Submissions are reviewed before listing.",
    "apply_submit": "Submit application",
    "apply_ok": "✓ Application submitted",
    "apply_ok_sub": "Your application is in the review queue.<br>Results will be notified on the platform.",
    "th_project": "Project / Time",
    "th_qty": "Qty",
    "th_coin": "Coin",
    "th_spent": "Spent",
    "th_status": "Status",
    "th_gen": "Level",
    "th_count": "Members",
    "th_amount": "Reward",
    "th_date": "Time",
    "th_team_no": "#",
    "th_team_addr": "Direct referral",
    "status_done": "Completed",
    "card_price_note": "Single-coin payment · set by issuer",
    "next_price": "Next NFT price",
    "step_note": "Step-up: price of #n = start + (n-1) × increment",
    "step_note_c": "Step-up · start {start} / NFT · +{inc} each",
    "empty_p": "No purchases yet · subscribe to start your film journey",
    "empty_r": "No referral rewards yet",
    "empty_t": "No referral team yet",
    "toast_save": "Browser storage unavailable; check browser settings",
    "toast_connected": "Wallet connected",
    "toast_wallet": "Wallet connected",
    "toast_connect": "Please connect your wallet first",
    "toast_qty": "Enter an integer from 1 to {max}",
    "toast_risk": "Please read and check the risk notice first",
    "toast_buy": "Subscription recorded: {n} NFTs",
    "toast_copied": "Referral link copied",
    "toast_copy_manual": "Press Ctrl+C to copy the selected link",
    "toast_img_type": "Please choose a JPG / PNG image",
    "toast_img_size": "Image must be under 5MB; compress and retry",
    "toast_img_ready": "NFT cover ready",
    "toast_img_fail": "Image read failed; try another",
    "toast_need_image": "Please upload an NFT cover first",
    "toast_applied": "Issuer application submitted",
    "toast_preview": "Project saved",
    "toast_soldout": "Sold out",
    "toast_ref": "Referral tag recognized",
    "toast_input_pos": "Enter a positive integer",
    "ref_connect": "Please connect your wallet first",
    "buy_soldout": "Sold out",
    "my_hold": "Holding {n} NFTs",
    "record_name": "Butterfly Pictures",
    "user_pb": "Your NFT cover · pending review",
    "user_tag": "Pending review",
    "live_now": "● Raising",
    "user_sub2": "NFT cover uploaded with your application, awaiting platform review.",
    "view_preview": "View my project ↗",
    "poster_label_u": "NO. {n} / YOUR PICTURES",
    "result_note": "Project will be listed after approval.",
    "result_line": "Issuer · {issuer}　|　{pricing}　|　{supply} NFTs　|　{date}",
    "soldout_btn": "Sold out",
    "calc_title": "Subscription split reference",
    "f_description": "Project description",
    "f_description_ph": "Introduce the film and raise plan (stored in NFT metadata)",
    "empty_projects": "No on-chain projects yet<br>Be the first to launch",
    "apply_submitting": "Submitting on-chain…",
    "toast_launch_ok": "Project launched on-chain",
    "toast_subscribing": "Subscribing on-chain…",
    "toast_subscribe_ok": "Subscription successful",
    "toast_chain_load": "Syncing on-chain projects…",
    "toast_chain_fail": "Failed to load on-chain data",
    "toast_img_uploading": "Uploading cover…",
    "toast_img_upload_fail": "Cover upload failed; retry",
    "toast_launch_pay_token": "Pay token not enabled on-chain; use AAPLB to launch",
    "coin_launch_off": "Not enabled on-chain",
    "buy_need_address": "NFT contract address missing",
    "toast_no_card_address": "Cannot subscribe without NFT contract address"
  },
  "de": {
    "nav_home": "Projekte",
    "nav_rules": "Regeln",
    "nav_dash": "Mein Konto",
    "network": "BSC Mainnet",
    "wallet_btn": "◇ Wallet verbinden",
    "wallet_on": "◈ Verbunden",
    "hero_eyebrow": "Geschichten verdienen eine Zukunft",
    "hero_h1": "Lass gute Geschichten sichtbar werden<br>Lass jede Beteiligung, <span>ein Echo finden</span>",
    "hero_p": "Filmemacher mit Mitgestaltern verbinden<br>NFT dokumentiert Teilnahme · transparentes Film-Fundraising.",
    "hero_explore": "Projekte entdecken",
    "hero_launch": "＋ Projekt starten",
    "hero_caption": "A NEW CHAPTER IN CINEMA INVESTMENT",
    "stat1": "Gelistete Projekte",
    "stat1u": "",
    "stat2": "NFT-Gesamtauflage",
    "stat2u": "NFTs",
    "stat3": "Vom Emittent wählbarer Preis",
    "stat3u": "eine Währung · projektbestimmt",
    "stat4": "Max. Empfehlungsprämie",
    "stat4u": "bis zu 15 Ebenen",
    "poster_label": "NR. {n} / ORIGINAL PICTURES",
    "sec_projects": "Große Geschichten entdecken",
    "sec_projects_sub": "Unabhängige Emission · Eigene Regeln · Gemeinsame Teilnahme",
    "filter_all": "Alle",
    "filter_live": "Aktiv",
    "filter_soon": "Demnächst",
    "poster_bottom": "Jedes kleine Licht wird eines Tages auf der Leinwand leuchten",
    "tag_debut": "Plattform-Debüt",
    "live_demo": "● Live",
    "sub_issuer": "Emittent",
    "sub_nft": "Mit einem NFT die Geburt einer Geschichte erleben.",
    "sub_issuer_nft": "Emittent · Butterfly Pictures<br>Mit einem NFT die Geburt einer Geschichte erleben.",
    "price_unit": "/ NFT",
    "progress_label": "Zeichnungsfortschritt",
    "limited": "Begrenzt",
    "view_project": "Projekt ansehen & teilnehmen ↗",
    "launch_title": "Die nächste große Geschichte beginnt mit dir",
    "launch_sub": "Eine offene Fundraising-Plattform für Filmemittenten.<br>Projekt zeigen, NFTs ausgeben, Unterstützer verbinden.",
    "launch_steps": "01 &nbsp; Projektdaten einreichen<br>02 &nbsp; Rechte & Regeln festlegen<br>03 &nbsp; Finanzierung öffnen",
    "launch_btn": "Emittent werden ↗",
    "empty_soon": "Neue Geschichten sind in Vorbereitung<br>Noch keine anstehenden Projekte",
    "feat1": "Teilnahme, dokumentiert",
    "feat1p": "Jedes NFT entspricht einem Teilnahmerecord<br>On-Chain und Rechte gemäß Emittenten-Offenlegung",
    "feat2": "Klare Umsatzverteilung",
    "feat2p": "Emittent erhält mind. 70%, Empfehlung bis 30%<br>Nicht zugeteilte Prämien gehen an den Emittenten",
    "feat3": "Unabhängige Emission & Offenlegung",
    "feat3p": "Emittenten legen künftige Ertragsregeln offen<br>Keine Plattformgarantie oder On-Chain-Dividende",
    "detail_back": "← Zurück zu Projekten",
    "detail_tag": "Debüt #001",
    "detail_live": "● Zeichnung offen",
    "detail_sub": "Emittent: {issuer} &nbsp;/&nbsp; {supply} NFTs &nbsp;/&nbsp; {price} · {coin} je Stück",
    "notice_demo": "Ob ein NFT durchsetzbare Anteilsrechte darstellt, richtet sich nach Vereinbarung und Recht. Zeichnungs- und Prämienregeln folgen Plattform und Emittent.",
    "about_title": "Über das Projekt",
    "about_p1": "Butterfly Pictures ist das erste Vorzeigeprojekt der Plattform und gibt 1.000 Projekt-NFTs aus. Teilnahme mit AAPLB / USDT / BNB, wahlweise festem oder steigendem Preis — im Steigermodus kostet das 1. NFT 1 AAPLB, +0,1 AAPLB pro NFT, Start und Schritt konfiguriert der Emittent.",
    "about_p2": "Genre, Produktionsteam, Budget, Drehfortschritt und Rechtsdokumente stehen zur Offenlegung aus. Diese Plattform erfindet keine Filmhistorie, Anlageerfolge oder Ertragsversprechen.",
    "tag_film": "Filmprojekt",
    "tag_nft": "Limitierte NFTs",
    "tag_issue": "Selbst emittiert",
    "sub_title": "Am Projekt teilnehmen",
    "supply_total": "Gesamtauflage",
    "supply_total_v": "1.000 NFTs",
    "supply_left": "Gezeichnet / Rest",
    "target": "Zielsumme",
    "target_v": "1.000 AAPLB",
    "my_holding": "Mein Bestand",
    "buy_btn": "Teilnehmen ↗",
    "buy_note": "Wallet verbinden und On-Chain-Zahlung abschließen",
    "alloc_title": "Verteilung der Kaufsumme",
    "alloc_issuer": "Basisanteil Emittent",
    "alloc_level": "Upline je Ebene",
    "alloc_note": "Der Upline-Pool beträgt höchstens 30% der Kaufsumme. Bei weniger als 15 Ebenen geht der Rest an den Emittenten.",
    "view_rules": "Berechnungsregeln ansehen →",
    "revenue_title": "Künftige Ertragsverteilung",
    "revenue_tag": "Offenlegung · Nur Anzeige",
    "donut_label": "Verteilungsstruktur",
    "revenue_note": "Dieser Plan ist getrennt von der 70% / 30%-Kaufverteilung. Künftige Ertragsdarstellung des Emittenten, kein Ertragsversprechen.",
    "alloc_director": "Regie",
    "alloc_writer": "Drehbuch",
    "alloc_distributor": "Verleih",
    "alloc_producer": "Produktionsfirma",
    "alloc_partner": "Butterfly-Partner",
    "alloc_treasury": "Butterfly-Reserve",
    "alloc_buyback": "Rückkauf & Verbrennung",
    "alloc_marshal": "Marshal-NFT-Inhaber",
    "alloc_metal": "Gold-Silber-Kupfer-NFT",
    "alloc_investor": "Investoren",
    "rules_title": "Klare Regeln, transparente Teilnahme",
    "rules_sub": "Kaufverteilung und künftige Projekterträge getrennt — jede Teilnahme nachvollziehbar.",
    "rules_h3": "Debütprojekt · Kaufverteilungsregeln",
    "step1b": "01 / Teilnahme",
    "step1p": "Zahlen mit AAPLB · USDT · BNB<br>Fester oder steigender Preis · Butterfly Pictures gibt 1.000 fix aus",
    "step2b": "02 / Empfehlungsverteilung",
    "step2p": "Jede Upline erhält 2% des Betrags<br>Bis zu 15 Ebenen, max. 30%",
    "step3b": "03 / Emittent erhält",
    "step3p": "Emittent erhält Basis-70%<br>Restprämien unter 15 Ebenen gehen an den Emittenten",
    "notice_rules": "Die 2% stammen aus jeder Kaufsumme, ohne Zusatzgebühr für Käufer. Beispiel: 1 NFT mit 3 gültigen Uplines — Uplines erhalten 0,06 AAPLB, Emittent 0,94 AAPLB.",
    "prelaunch_title": "Vor dem Start zu klären",
    "li1": "Rechtsverhältnis zwischen Anteilen, Erträgen und NFT sowie schriftliche Vereinbarungen.",
    "li2": "Anlegereignung, Emissionsqualifikation, Gebietsbeschränkungen und Identitätsprüfung.",
    "li3": "Kette, Token-Adresse und Dezimalstellen von AAPLB.",
    "li4": "Bindungszeitpunkt von Empfehlungen, Selbstempfehlungsschutz und Kreislaufregeln.",
    "li5": "15-Ebenen-Berechtigung, Auszahlung und Sonderfälle bei Adressen.",
    "li6": "Laufzeit, Rückerstattung bei Nichterreichen und Verwahrung.",
    "li7": "Sicherheitsaudit der Smart Contracts und Projektoffenlegung.",
    "notice_compliance": "Film-Anteilsfinanzierung und mehrstufige Empfehlungen bergen Compliance-Risiken. Vor dem Start ist eine fachliche Rechtsprüfung erforderlich. Diese Plattform ist weder Emissionslizenz noch Anlageberatung.",
    "dash_title": "Jede Teilnahme zählt",
    "dash_tag": "Persönliche Daten",
    "acc_off": "Wallet nicht verbunden",
    "acc_on": "Wallet verbunden",
    "m1": "Gesamt gekauft",
    "m1u": "NFTs · On-Chain-Bestand",
    "m2": "Ausgegeben",
    "m2u": "AAPLB",
    "m3": "Direkte Empfehlungen",
    "m3u": "Team 0 · noch nicht gebunden",
    "m4": "Empfehlungsprämien gesamt",
    "m4u": "AAPLB · noch keine Prämien",
    "tab_p": "Käufe",
    "tab_r": "Prämien",
    "tab_t": "Team",
    "share_title": "Geschichten teilen, Begleiter einladen",
    "share_sub": "Mein Empfehlungslink<br>2% je gültiger Upline, max. 15 Ebenen.",
    "copy": "Kopieren",
    "share_note": "Empfehlungslinks können ein Kennzeichen tragen; Prämien folgen gültigen Upline-Beziehungen.",
    "my_nft": "Meine NFTs",
    "nft_name": "Butterfly Pictures · Runde 1",
    "nft_none": "Noch nicht teilgenommen",
    "view": "Ansehen",
    "footer1": "Kreativität und Teilnahme verbinden — Geschichten mehr Möglichkeiten geben.",
    "footer2": "Keine Renditeversprechen · Verlustrisiko",
    "footer3": "Ein NFT ist nicht automatisch rechtliches Eigenkapital; Verlustrisiko besteht.",
    "wallet_title": "Wallet verbinden",
    "wallet_sub": "Wallet mit BSC Mainnet verbinden für Teilnahme und On-Chain-Interaktion.",
    "wallet_notice": "Nach dem Verbinden können Sie zeichnen, Bestände einsehen und Ihren Empfehlungslink nutzen.",
    "wallet_enter": "Verbinden",
    "purchase_title": "Butterfly-Pictures-NFT erwerben",
    "purchase_sub": "Ein-Währungs-Teilnahme &nbsp;·&nbsp; Gesamt 1.000",
    "buy_qty": "Anzahl",
    "pay": "Zahlung",
    "pay_coin": "Zahlen mit",
    "pay_coin_note": "Dieses Projekt akzeptiert nur eine Währung",
    "upline": "Gültige Uplines",
    "upline_v": "0 Ebenen (nicht gebunden)",
    "issuer_pay": "Emittent-Eingang (inkl. Rest)",
    "risk_check": "Ich verstehe: NFT-Rechte folgen der Vereinbarung; Filmerträge unsicher, keine Versprechen auf dieser Seite.",
    "confirm_buy": "Zeichnung bestätigen",
    "purchase_note": "Menge und Zahlungsbetrag bestätigen",
    "apply_title": "Lass deine Geschichte hier anlaufen",
    "apply_sub": "Emittenten-Onboarding · zur Prüfung eingereicht",
    "f_project": "Projektname",
    "f_project_ph": "Filmprojektname eingeben",
    "f_issuer": "Emittent",
    "f_issuer_ph": "Firma oder Emittentenname",
    "f_mode": "Preismodell",
    "mode_fixed": "Fester Preis",
    "mode_step": "Steigernd",
    "f_price_fixed": "Fester Stückpreis",
    "f_price_step": "Steigerungsparameter",
    "unit_price": "Stückpreis",
    "start_price": "Startpreis",
    "step_price": "Schritt / NFT",
    "f_supply": "Geplante NFT-Auflage",
    "f_supply_ph": "z. B. 1000",
    "f_image": "NFT-Cover <em class=\"req\">(erforderlich)</em>",
    "upload_hint": "＋ NFT-Cover hochladen<br><small>JPG / PNG, 1:1 empfohlen, ≤ 5MB</small>",
    "apply_notice": "Qualifikation und Rechte-Offenlegung erforderlich. Prüfung vor Listing.",
    "apply_submit": "Antrag einreichen",
    "apply_ok": "✓ Antrag eingereicht",
    "apply_ok_sub": "Antrag in der Prüfwarteschlange.<br>Ergebnis über die Plattform.",
    "th_project": "Projekt / Zeit",
    "th_qty": "Anz.",
    "th_coin": "Coin",
    "th_spent": "Ausgegeben",
    "th_status": "Status",
    "th_gen": "Ebene",
    "th_count": "Mitglieder",
    "th_amount": "Prämie",
    "th_date": "Zeit",
    "th_team_no": "Nr.",
    "th_team_addr": "Direkte Empfehlung",
    "status_done": "Abgeschlossen",
    "card_price_note": "Ein-Währungs-Zahlung · vom Emittent festgelegt",
    "next_price": "Preis nächstes NFT",
    "step_note": "Steigerung: Preis Nr. n = Start + (n-1) × Schritt",
    "step_note_c": "Steigerung · Start {start} / NFT · +{inc} je Stück",
    "empty_p": "Noch keine Zeichnungen · zeichnen Sie, um zu starten",
    "empty_r": "Noch keine Empfehlungsprämien",
    "empty_t": "Noch kein Empfehlungsteam",
    "toast_save": "Browserspeicher nicht verfügbar; Einstellungen prüfen",
    "toast_connected": "Wallet verbunden",
    "toast_wallet": "Wallet verbunden",
    "toast_connect": "Bitte zuerst Wallet verbinden",
    "toast_qty": "Ganze Zahl von 1 bis {max} eingeben",
    "toast_risk": "Bitte zuerst Risikohinweis lesen und aktivieren",
    "toast_buy": "Zeichnung erfasst: {n} NFTs",
    "toast_copied": "Empfehlungslink kopiert",
    "toast_copy_manual": "Drücke Strg+C zum Kopieren des Links",
    "toast_img_type": "Bitte JPG / PNG wählen",
    "toast_img_size": "Bild max. 5MB; komprimieren und erneut versuchen",
    "toast_img_ready": "NFT-Cover bereit",
    "toast_img_fail": "Bild konnte nicht gelesen werden; anderes wählen",
    "toast_need_image": "Bitte zuerst NFT-Cover hochladen",
    "toast_applied": "Emittentenantrag eingereicht",
    "toast_preview": "Projekt gespeichert",
    "toast_soldout": "Ausverkauft",
    "toast_ref": "Empfehlungsmarker erkannt",
    "toast_input_pos": "Positive ganze Zahl eingeben",
    "ref_connect": "Bitte zuerst Wallet verbinden",
    "buy_soldout": "Ausverkauft",
    "my_hold": "{n} NFTs im Bestand",
    "record_name": "Butterfly Pictures",
    "user_pb": "Dein NFT-Cover · in Prüfung",
    "user_tag": "Prüfung ausstehend",
    "live_now": "● Läuft",
    "user_sub2": "NFT-Cover wurde mit der Bewerbung hochgeladen, Prüfung ausstehend.",
    "view_preview": "Mein Projekt ansehen ↗",
    "poster_label_u": "NO. {n} / YOUR PICTURES",
    "result_note": "Projekt wird nach Freigabe gelistet.",
    "result_line": "Emittent · {issuer}　|　{pricing}　|　{supply} NFTs　|　{date}",
    "soldout_btn": "Ausverkauft",
    "calc_title": "Zeichnungsverteilung – Referenz",
    "f_description": "Projektbeschreibung",
    "f_description_ph": "Film und Emissionsplan (wird in NFT-Metadaten gespeichert)",
    "empty_projects": "Noch keine On-Chain-Projekte<br>Starten Sie das erste Projekt",
    "apply_submitting": "On-Chain wird übermittelt…",
    "toast_launch_ok": "Projekt on-chain gestartet",
    "toast_subscribing": "On-Chain-Zeichnung…",
    "toast_subscribe_ok": "Zeichnung erfolgreich",
    "toast_chain_load": "On-Chain-Projekte werden geladen…",
    "toast_chain_fail": "On-Chain-Daten konnten nicht geladen werden",
    "toast_img_uploading": "Cover wird hochgeladen…",
    "toast_img_upload_fail": "Upload fehlgeschlagen; erneut versuchen",
    "toast_launch_pay_token": "Zahltoken on-chain nicht aktiv; AAPLB für Start nutzen",
    "coin_launch_off": "On-chain inaktiv",
    "buy_need_address": "NFT-Vertragsadresse fehlt",
    "toast_no_card_address": "Zeichnung ohne NFT-Adresse nicht möglich"
  },
  "ko": {
    "nav_home": "프로젝트",
    "nav_rules": "규칙",
    "nav_dash": "내 정보",
    "network": "BSC 메인넷",
    "wallet_btn": "◇ 지갑 연결",
    "wallet_on": "◈ 연결됨",
    "hero_eyebrow": "좋은 이야기는 미래를 가진다",
    "hero_h1": "좋은 이야기가 보이게 하라<br>모든 참여가, <span>울림이 되게 하라</span>",
    "hero_p": "영화 제작자와 가치 공동창작자를 연결합니다<br>NFT가 참여를 기록합니다 · 투명한 영화 펀딩.",
    "hero_explore": "프로젝트 둘러보기",
    "hero_launch": "＋ 프로젝트 시작",
    "hero_caption": "A NEW CHAPTER IN CINEMA INVESTMENT",
    "stat1": "등록 프로젝트",
    "stat1u": "",
    "stat2": "플랫폼 NFT 발행량",
    "stat2u": "장",
    "stat3": "발행사 선택 가격",
    "stat3u": "단일 코인 · 프로젝트 지정",
    "stat4": "최대 추천 보상",
    "stat4u": "최대 15대",
    "poster_label": "NO. {n} / ORIGINAL PICTURES",
    "sec_projects": "좋은 이야기 발견",
    "sec_projects_sub": "독립 발행 · 자체 규칙 · 공동 참여",
    "filter_all": "전체",
    "filter_live": "모집 중",
    "filter_soon": "곧 출시",
    "poster_bottom": "작은 빛 하나, 언젠가 스크린에서 빛납니다",
    "tag_debut": "플랫폼 첫 프로젝트",
    "live_demo": "● 모집 중",
    "sub_issuer": "발행사",
    "sub_nft": "NFT 한 장으로, 이야기의 탄생에 참여하세요.",
    "sub_issuer_nft": "발행사 · 버터플라이 픽처스<br>NFT 한 장으로, 이야기의 탄생에 참여하세요.",
    "price_unit": "/ 장 NFT",
    "progress_label": "구매 진행률",
    "limited": "한정 발행",
    "view_project": "프로젝트 보기 & 참여 ↗",
    "launch_title": "다음 위대한 이야기는 당신에게서 시작됩니다",
    "launch_sub": "영화 발행사를 위한 개방형 펀딩 플랫폼.<br>프로젝트를 소개하고, NFT를 발행하고, 후원자를 연결하세요.",
    "launch_steps": "01 &nbsp; 프로젝트 자료 제출<br>02 &nbsp; 권리와 규칙 명시<br>03 &nbsp; 모금 시작",
    "launch_btn": "발행사 되기 ↗",
    "empty_soon": "새로운 이야기가 준비 중입니다<br>곧 출시될 프로젝트가 아직 없습니다",
    "feat1": "참여가 기록됩니다",
    "feat1p": "NFT 한 장이 프로젝트 참여 기록에 대응합니다<br>온체인 기록 및 권리는 발행사 공시 기준",
    "feat2": "명확한 분배 규칙",
    "feat2p": "발행사 최소 70%, 추천 최대 30%<br>미배분 보상은 발행사에 귀속",
    "feat3": "독립 발행, 독립 공시",
    "feat3p": "발행사가 미래 수익 배분 규칙을 공시<br>플랫폼 보증이나 온체인 배당 아님",
    "detail_back": "← 프로젝트로 돌아가기",
    "detail_tag": "첫 프로젝트 #001",
    "detail_live": "● 구매 오픈",
    "detail_sub": "발행사: {issuer} &nbsp;/&nbsp; {supply}장 NFT &nbsp;/&nbsp; 장당 {price} · {coin}",
    "notice_demo": "NFT가 집행 가능한 지분 권리를 의미하는지는 공식 계약 및 적용 법률에 따릅니다. 구매 및 보상 규칙은 플랫폼·발행사 공시 기준입니다.",
    "about_title": "프로젝트 소개",
    "about_p1": "버터플라이 픽처스는 플랫폼의 첫 번째 쇼케이스 프로젝트로, 1,000장의 프로젝트 NFT를 발행합니다. AAPLB / USDT / BNB 세 코인으로 구매할 수 있으며, 고정가 또는 증가형 가격 중 선택할 수 있습니다 — 증가형에서는 1번째 NFT가 1 AAPLB, 장당 +0.1 AAPLB이며 시작가와 증가분은 모두 발행사가 설정합니다.",
    "about_p2": "장르, 제작팀, 예산, 촬영 진행 및 법률 문서는 발행사 공시 대기 중입니다. 본 플랫폼은 허위 영화 이력·투자 실적·수익 약속을 만들지 않습니다.",
    "tag_film": "영화 프로젝트",
    "tag_nft": "한정 NFT",
    "tag_issue": "자체 발행",
    "sub_title": "프로젝트 구매에 참여",
    "supply_total": "총 발행량",
    "supply_total_v": "1,000장",
    "supply_left": "구매 완료 / 잔여",
    "target": "모금 목표",
    "target_v": "1,000 AAPLB",
    "my_holding": "내 보유",
    "buy_btn": "구매 참여 ↗",
    "buy_note": "지갑 연결 후 온체인 결제로 구매",
    "alloc_title": "구매금 분배",
    "alloc_issuer": "발행사 기본 수익",
    "alloc_level": "대별 업라인",
    "alloc_note": "업라인 보상 풀은 구매금의 최대 30%입니다. 15대 미만이면 미배분분은 자동으로 발행사에 귀속됩니다.",
    "view_rules": "계산 규칙 보기 →",
    "revenue_title": "미래 수익 배분안",
    "revenue_tag": "발행사 공시 · 표시 전용",
    "donut_label": "배분 구성",
    "revenue_note": "이 안은 구매 자금 70% / 30% 분배와 별개 규칙입니다. 발행사 공시의 미래 수익 표시일 뿐 수익 약속이 아닙니다.",
    "alloc_director": "감독",
    "alloc_writer": "각본",
    "alloc_distributor": "배급사",
    "alloc_producer": "제작사",
    "alloc_partner": "버터플라이 파트너",
    "alloc_treasury": "버터플라이 금고",
    "alloc_buyback": "바이백 소각",
    "alloc_marshal": "마샬 NFT 주주",
    "alloc_metal": "금은동 NFT 주주",
    "alloc_investor": "투자자",
    "rules_title": "명확한 규칙, 투명한 참여",
    "rules_sub": "구매금 분배와 프로젝트 미래 수익을 구분하여, 모든 참여에 근거를 둡니다.",
    "rules_h3": "첫 프로젝트 · 구매 분배 규칙",
    "step1b": "01 / 구매",
    "step1p": "AAPLB · USDT · BNB 결제 지원<br>고정 또는 증가형 가격 · 버터플라이 픽처스 고정 1,000장 발행",
    "step2b": "02 / 추천 분배",
    "step2p": "각 업라인이 구매금의 2% 수령<br>최대 15대, 누적 30% 이하",
    "step3b": "03 / 발행사 입금",
    "step3p": "발행사 기본 70% 수령<br>15대 미만의 잔여 보상은 발행사 귀속",
    "notice_rules": "2%는 매 구매금에서 발생하며 구매자에게 추가 비용이 없습니다. 예: NFT 1장, 유효 업라인 3대 — 업라인 합계 0.06 AAPLB, 발행사 0.94 AAPLB 수령.",
    "prelaunch_title": "출시 전에 확정할 사항",
    "li1": "지분·수익권과 NFT의 법적 관계 및 서면 계약.",
    "li2": "투자자 적격성, 발행 자격, 지역 제한과 신원 확인.",
    "li3": "AAPLB 체인, 토큰 주소와 소수점 자리.",
    "li4": "추천 관계 바인딩 시점, 자기추천 방지 및 순환 관계 규칙.",
    "li5": "15대 보상 자격, 출금 메커니즘과 이상 주소 처리.",
    "li6": "모금 기간, 목표 미달 시 환불과 자금 관리.",
    "li7": "컨트랙트 보안 감사와 프로젝트 자료 공시.",
    "notice_compliance": "영화 지분 모금과 다단계 추천은 규제 리스크가 있습니다. 관할 지역의 법률 검토가 필요합니다. 본 플랫폼은 발행 허가나 투자 조언이 아닙니다.",
    "dash_title": "모든 참여, 전부 의미 있습니다",
    "dash_tag": "개인 데이터",
    "acc_off": "지갑 미연결",
    "acc_on": "지갑 연결됨",
    "m1": "누적 구매",
    "m1u": "NFT · 온체인 보유",
    "m2": "구매 지출",
    "m2u": "AAPLB",
    "m3": "직접 추천 인원",
    "m3u": "팀 0명 · 아직 바인딩 없음",
    "m4": "누적 추천 보상",
    "m4u": "AAPLB · 아직 보상 없음",
    "tab_p": "구매 기록",
    "tab_r": "보상 기록",
    "tab_t": "추천 팀",
    "share_title": "좋은 이야기를 공유하고 동행자를 초대하세요",
    "share_sub": "내 추천 링크<br>유효 업라인 기준 2%, 최대 15대 분배.",
    "copy": "복사",
    "share_note": "추천 링크에 표식이 포함될 수 있으며, 유효 상위 관계로 분배합니다.",
    "my_nft": "내 NFT",
    "nft_name": "버터플라이 픽처스 · 1기",
    "nft_none": "아직 구매 전",
    "view": "보기",
    "footer1": "창작과 참여를 연결하여, 이야기에 더 많은 가능성을.",
    "footer2": "투자 수익 미약속 · 원금 손실 위험",
    "footer3": "NFT가 당연히 법적 지분을 의미하지 않으며, 원금 손실 위험이 있습니다.",
    "wallet_title": "지갑 연결",
    "wallet_sub": "BSC 메인넷 지갑을 연결하여 구매 및 온체인 상호작용을 진행하세요.",
    "wallet_notice": "연결 후 구매, 보유 내역 확인 및 추천 링크를 사용할 수 있습니다.",
    "wallet_enter": "연결",
    "purchase_title": "버터플라이 픽처스 NFT 구매",
    "purchase_sub": "단일코인 구매 &nbsp;·&nbsp; 총 1,000장",
    "buy_qty": "구매 수량",
    "pay": "지불",
    "pay_coin": "결제 코인",
    "pay_coin_note": "이 프로젝트는 한 가지 코인만 지원합니다",
    "upline": "유효 업라인",
    "upline_v": "0대 (바인딩 없음)",
    "issuer_pay": "발행사 입금 (잔여 포함)",
    "risk_check": "NFT 권리는 공식 계약 기준이며, 영화 수익은 불확실하고 본 페이지는 수익을 약속하지 않습니다.",
    "confirm_buy": "구매 확인",
    "purchase_note": "구매 수량과 결제 금액을 확인하세요",
    "apply_title": "당신의 이야기를 여기서 시작하세요",
    "apply_sub": "발행사 입점 · 제출 후 심사",
    "f_project": "프로젝트 이름",
    "f_project_ph": "영화 프로젝트 이름 입력",
    "f_issuer": "발행 주체",
    "f_issuer_ph": "회사 또는 발행사 이름",
    "f_mode": "가격 모드",
    "mode_fixed": "고정 가격",
    "mode_step": "증가형",
    "f_price_fixed": "고정 단가",
    "f_price_step": "증가 파라미터",
    "unit_price": "단가",
    "start_price": "시작가",
    "step_price": "장당 증가분",
    "f_supply": "계획 NFT 발행 수량",
    "f_supply_ph": "예: 1000",
    "f_image": "NFT 커버 <em class=\"req\">(필수)</em>",
    "upload_hint": "＋ NFT 커버 업로드<br><small>JPG / PNG, 1:1 권장, ≤ 5MB</small>",
    "apply_notice": "발행 자격 및 권리 공시 필요. 심사 후 listing.",
    "apply_submit": "신청 제출",
    "apply_ok": "✓ 신청 제출됨",
    "apply_ok_sub": "심사 대기열에 등록되었습니다.<br>결과는 플랫폼으로 안내됩니다.",
    "th_project": "프로젝트 / 시간",
    "th_qty": "수량",
    "th_coin": "코인",
    "th_spent": "지출",
    "th_status": "상태",
    "th_gen": "세대",
    "th_count": "인원",
    "th_amount": "보상",
    "th_date": "시간",
    "th_team_no": "번호",
    "th_team_addr": "직접 추천 주소",
    "status_done": "완료",
    "card_price_note": "단일코인 결제 · 발행사 지정",
    "next_price": "다음 장 가격",
    "step_note": "증가형: n번째 가격 = 시작가 + (n-1) × 장당 증가분",
    "step_note_c": "증가형 · 시작 {start} / 장 · 장당 +{inc}",
    "empty_p": "구매 내역 없음 · 구매로 영화 여정을 시작하세요",
    "empty_r": "추천 보상 없음",
    "empty_t": "추천 팀 없음",
    "toast_save": "브라우저 저장소를 사용할 수 없습니다. 설정을 확인하세요.",
    "toast_connected": "지갑 연결됨",
    "toast_wallet": "지갑 연결됨",
    "toast_connect": "먼저 지갑을 연결하세요",
    "toast_qty": "1부터 {max} 사이의 정수를 입력하세요",
    "toast_risk": "먼저 위험 고지에 동의하세요",
    "toast_buy": "구매 완료, {n}장 NFT 기록",
    "toast_copied": "추천 링크 복사됨",
    "toast_copy_manual": "Ctrl+C를 눌러 선택한 링크를 복사하세요",
    "toast_img_type": "JPG / PNG 이미지를 선택하세요",
    "toast_img_size": "이미지는 5MB 이하여야 합니다. 압축 후 재시도",
    "toast_img_ready": "NFT 커버 준비 완료",
    "toast_img_fail": "이미지 읽기 실패. 다른 이미지로 시도",
    "toast_need_image": "먼저 NFT 커버를 업로드하세요",
    "toast_applied": "발행 신청 제출됨",
    "toast_preview": "프로젝트 저장됨",
    "toast_soldout": "매진",
    "toast_ref": "추천 표식 인식됨",
    "toast_input_pos": "양의 정수를 입력하세요",
    "ref_connect": "먼저 지갑을 연결하세요",
    "buy_soldout": "매진",
    "my_hold": "{n}장 NFT 보유",
    "record_name": "버터플라이 픽처스",
    "user_pb": "발행한 NFT 커버 · 심사 대기",
    "user_tag": "심사 대기",
    "live_now": "● 모집 중",
    "user_sub2": "NFT 커버가 신청과 함께 업로드되었습니다. 플랫폼 심사를 기다립니다.",
    "view_preview": "내 프로젝트 보기 ↗",
    "poster_label_u": "NO. {n} / YOUR PICTURES",
    "result_note": "승인 후 프로젝트가 공개됩니다.",
    "result_line": "발행사 · {issuer}　|　{pricing}　|　{supply}장　|　{date}",
    "soldout_btn": "매진",
    "calc_title": "구매 분배 참고",
    "f_description": "프로젝트 소개",
    "f_description_ph": "영화 및 발행 계획 (NFT 메타데이터에 저장)",
    "empty_projects": "온체인 발행 프로젝트 없음<br>첫 프로젝트를 시작하세요",
    "apply_submitting": "온체인 제출 중…",
    "toast_launch_ok": "프로젝트 온체인 발행 완료",
    "toast_subscribing": "온체인 구매 중…",
    "toast_subscribe_ok": "구매 성공",
    "toast_chain_load": "온체인 프로젝트 동기화 중…",
    "toast_chain_fail": "온체인 데이터 로드 실패",
    "toast_img_uploading": "커버 업로드 중…",
    "toast_img_upload_fail": "업로드 실패, 다시 시도하세요",
    "toast_launch_pay_token": "온체인 미지원 결제 토큰입니다. AAPLB로 발행하세요",
    "coin_launch_off": "온체인 미지원",
    "buy_need_address": "NFT 계약 주소 없음",
    "toast_no_card_address": "NFT 주소 없어 구매 불가"
  }
};
